const ServiceActions = {
    UPDATE: 'UPDATE_SERVICES',
}

export default ServiceActions;